import type { Modifiers } from "@dnd-kit/abstract";
import { useSortable } from "@dnd-kit/react/sortable";
import clsx from "clsx";
import type { PropsWithChildren } from "react";
import React from "react";
import { DragIcon } from "@/components/icons";
import styles from "./styles.module.scss";

type SortableItemProps = {
  id: number | string;
  index: number;
  disabled?: boolean;
  modifiers?: Modifiers | undefined;
  withHandle?: boolean;
} & PropsWithChildren;

export function SortableItem(props: SortableItemProps) {
  const handleRef = React.useRef(null);
  const { ref } = useSortable({
    id: props.id,
    index: props.index,
    modifiers: props.modifiers,
    disabled: props.disabled,
    handle: handleRef,
  });

  return (
    <>
      {props.withHandle ? (
        <div className={clsx(styles.wrapper)} ref={ref}>
          <div className={styles.handle} ref={handleRef}>
            <DragIcon />
          </div>
          {props.children}
        </div>
      ) : (
        <div className={clsx(!props.disabled && styles.item)} ref={ref}>
          {props.children}
        </div>
      )}
    </>
  );
}
